const cancel = '取消'
const save = '儲存'

export default {
  global: {
    generalError: '啊！無法處理此請求。請重新載入頁面。',
    signature: '謹致問候！',
  },

  component: {
    actionBar: {
      actions: '動作',
      hideActions: '隱藏動作',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: '新增',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: '新增簡歷或其他所需附件',
      placeholderWithDescription: '加入要求的附件',
      remove: '移除',
      allowedFileTypes: '支援的檔案類型',
      errors: {
        size: '檔案太大，最大檔案大小為 5MB。',
        empty: '檔案沒有資料',
        invalidType: fileType => `對不起，出於安全原因，不允許使用 ${fileType} 檔案`,
        typeNotWhitelisted: '對不起，不允許使用此檔案類型。',
      },
    },

    agreeTos: {
      privacyLinkText: '隱私政策',
      termsLinkText: '條款和條件',
      privacyPolicyText: '我們重視您的隱私權，請閱讀我們的',
      termsText1: '請先閱讀並同意',
      termsText2: '，然後再向我們提供您的個人資料。',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `如果您不希望我們處理您的個人資料，您可以向 ${mail} 傳送訊息要求移除。`,
      customSupportPrivacyInfo: link => `如果您不希望我們處理您的個人資料，可以聯絡 ${link} 要求移除。`,
    },

    buttons: {
      close: '關閉',
    },

    competencies: {
      addCompetency: '新增新能力',
      edit: '修改能力',
      done: '完成',
      defaultsDescription: '如果您不確定使用什麼能力，我們已經定義了一些不錯的預設值。',
      getDefaults: '獲取預設值',
    },

    competency: {
      warning: '移除能力及其所有等級？',
    },

    confirmDelete: {
      delete: '刪除',
      cancel: '取消',
      confirm: '確認',
    },

    confirm: {
      cancel: '移除拍攝內容',
      confirm: '再試一次',
    },

    confirmButton: {
      wait: count => `等候 ${count}`,
      confirm: '確認',
    },

    controlStatus: {
      text: {
        empty: '填寫',
        valid: () => '準備就緒',
      },
      textarea: {
        empty: '填寫',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: '設定',
        valid: () => '準備就緒',
      },
      file: {
        empty: '選擇',
        valid: () => '變更',
      },
      list: {
        empty: '新增',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: '搜尋',
        valid: () => '準備就緒',
      },
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: '移除',
      importCsv: '匯入 CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: '電子郵件被退回。確保收件人收到了您的訊息。',
      },
      Permanent: {
        General: '電子郵件投遞失敗。收件人的電子郵件提供者拒絕接受該郵件。',
        NoEmail: '電子郵件地址不存在。',
        Suppressed: '由於之前幾次發送電子郵件都未成功，這次電子郵件未能投遞。',
      },
      Transient: {
        General: '電子郵件被退回。確保收件人收到了您的訊息。',
        MailboxFull: '收件人收件匣已滿。',
        MessageTooLarge: '訊息內容量過大。',
        ContentRejected: '訊息內容被拒絕。',
        AttachmentRejected: '附件被拒絕。',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS 訊息已新增到訊息佇列，等待投遞。',
      failed: '傳送 SMS 訊息失敗。',
      duplicate: '給出的號碼已歸屬面試的其他申請人。',
    },

    error403: {
      heading: '禁止存取',
      content: '請確保您已登入正確的帳戶，並已受邀在 Recright 中查看此職位。此外，請確保在同一時間僅在單個瀏覽器視窗中使用 Recright。',
      link: '頭版',
    },

    error404: {
      heading: '所請求的網頁不存在',
      content: '我們努力搜尋了您請求的位址，但是未找到該位址的網頁。也許您使用的是過期連結，或者不小心輸入了錯誤的位址。',
      link: '頭版',
    },

    error410: {
      heading: '已關閉',
      content: '無法顯示職位，因為該職位已關閉或申請期已結束。',
      link: '頭版',
    },

    calendarError: {
      heading: '連接行事曆失敗',
      content: '我們無法連接您的行事曆。請稍後再試，如果問題仍然存在，請聯絡我們的支援人員。',
    },

    flash: {
      starting: '正在初始化...',
      connection_error_hint: '無法建立網路連線。\n請嘗試重新載入頁面。',
      permission_hint: '您需要允許本網站使用您的網路攝影機和麥克風。',
      searching_camera_hint: '正在搜尋網路攝影機...',
      camera_reserved_hint: '其他應用程式或網頁佔用了您的網路攝影機。\n請關閉該應用程式並重新載入此頁面。',
      camera_reserved_hint_chrome_extra: '\n\n親愛的 Chrome 瀏覽器使用者，您需要在位址欄下方的對話方塊中允許 Recright 使用網路攝影機。',
      no_camera_hint: '未找到網路攝影機。',
      no_mic_hint: '未找到麥克風。',
      uploading_text: '正在上傳 ......',
      rtmpt_in_use: '如果網路系統\n管理員允許 RTMP，則不需要此步驟。請向我們詢問方法。',
      preview_text: '網路攝影機處於預覽模式',
      close_text: '關閉攝影機',
      remove_text: '移除拍攝內容',
      noflash_errortext_install: link => `您似乎沒有安裝 Adobe Flash Player。錄製影片需要 Flash 外掛程式。在此處獲取 Flash：${link}`,
      noflash_errortext_enable: link => `如果您已安裝 flash，但仍收到此訊息。請查看：${link}`,
      noflash_errortext_differentbrowser: '或者，您也可以嘗試使用支援 HTML5 錄製的瀏覽器。我們建議使用 Chrome 或 Firefox。',
    },

    footer: {
      terms: '使用者條款和條件',
      license: '一般服務條款',
      privacyPolicy: '隱私政策',
      customSupport: link => `請聯絡 ${link}`,
      accessibilityReport: '可存取性報告',
    },

    feedbackPulse: {
      howWouldYouRateInterview: '您如何評價您的面試體驗？',
      howWouldYouRateJobAd: '您如何評價您的申請體驗？',
      yourResponseIsAnonymous: '您的回覆是匿名的。',
      thankYouFeedback: '感謝您的回饋意見！',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    cookieConsentModal: {
      title: '我們的網站使用 Cookie',
      body: '接受所有 Cookie 即表示您同意在您的裝置上儲存 Cookie，以加強網站導覽、分析網站使用情況並協助我們的行銷工作。',
      learnMoreLinkText: '瞭解更多關於我們如何使用 Cookie 的資訊',
      learnMoreLink: 'https://get.recright.com/cookies/',
      manageCookies: '管理 Cookie',
      acceptAll: '接受所有 Cookie',
      manageTitle: '管理許可偏好設定',
      necessaryCookiesTitle: '必需的 Cookie',
      necessaryCookiesBody:
        '這些 Cookie 是網站運作所必需的，在我們的系統中無法關閉。',
      performanceCookiesTitle: '效能 Cookie',
      performanceCookiesBody:
        '透過這些 Cookie，我們可以計算造訪量和流量來源，從而衡量和改進網站的效能。',
      marketingCookiesTitle: '行銷 Cookie',
      marketingCookiesBody:
        '這種 Cookie 使我們能夠提供個人化廣告並衡量廣告效果。',
      functionalCookiesTitle: '功能性 Cookie',
      functionalCookiesBody:
        '這種 Cookie 用於增強網站的功能。如果沒有這些 Cookie，某些功能可能無法使用。功能性 Cookie 的範例包括網路聊天服務和使用者偏好。',
      confirmChoices: '確認我的選擇',
    },

    formErrors: {
      typeNotWhitelisted: '對不起，不允許使用此檔案類型。',
      isRequired: '此欄位為必填欄位。',
      isEmail: value => `${value} 不是有效的電子郵件。`,
      isDate: value => `${value} 不是有效的日期。`,
      invalidUrl: 'URL 無效。',
      singleHireEndError: '單次招聘不能超過 60 天。',
      isNotTooOldForLive: '日期已是過去的日期。',
      isNotAfterEndDate: '所選日期不能在招聘廣告關閉日期之後。',
      isValidMobilePhone: value =>
        `${value ? `${value} 不是` : '不是'} 有效的行動電話號碼。`,
      isInternationalPhoneNumber: '電話號碼必須按國際格式填寫。',
      duplicateNumber: '電話號碼已新增。',
      duplicateCompetency: '具有此名稱的能力已經存在',
      isNotDuplicateTemplateName: '具有此名稱的範本已經存在。',
    },

    jobAdApplication: {
      name: '姓名',
      city: '原籍',
      email: '電子郵件地址',
      phone: '電話號碼',
      applyForPosition: '申請職位',
      back: '返回',
      continue: '繼續',
      submit: '提交',
      saveForLater: '稍後繼續',
      namePlaceholder: '輸入您的姓名',
      emailPlaceholder: '輸入您的電子郵件地址',
      phonePlaceholder: '輸入您的電話號碼',
      cityPlaceholder: '輸入您目前的常住地',
      links: '新增連結，例如您的 LinkedIn 個人資料',
      legendBasicInfo: '基本資料',
      legendLinks: '連結',
      legendAttachments: '附件',
      legendAdditionalFields: '其他資訊',
      coverLetter: '求職信',
      attachments: '附件',
      introduction: '在此處寫下您的簡短介紹',
      thankYou: '謝謝。',
      luck: '祝您好運！',
      close: '關閉',
      required: '標有星號 * 的項目為必填項目。',
    },

    jobAdContainer: {
      endTime: date => (date ? `應聘時間截至 ${date}` : ''),
    },

    jobAdDetails: {
      apply: '申請職位',
    },

    jobAdQuickInterview: {
      back: '返回',
      submit: '提交',
      saveForLater: '稍後繼續',
      title: '快速影片面試',
      description: '為了更快地瞭解您，我們希望您簡要回答我們的快速面試問題。體現您的個性和精神狀態。',
      requiredNote: '請注意，這只是申請流程的一部分，招聘人員只有在您錄製回答後才會收到您的申請。',
      reminderNote: '您可以立即錄製回答，也可以在收到電子郵件提醒後開始錄製。',
    },

    jobAdRow: {
      responses: '申請',
      status: {
        open: '空缺',
        filled: '已招滿',
        cancelled: '已取消',
        done: '完成',
        close: '關閉',
        draft: '已關閉（草稿）',
        hidden: '已隱藏',
      },
    },

    interviewRow: {
      responses: '申請人',
    },

    linkedInProfile: {
      showLinkedInProfileModal: '顯示 LinkedIn 個人資料',
    },

    linkedInButton: {
      error: '擷取個人資料時出錯。請重試。',
      buttonText: '透過 LinkedIn 申請',
    },

    linkedInContainer: {
      linkedInButtonDescription: '您可以使用 LinkedIn 個人資料預填寫申請表',
      linkedInOr: '或者',
      error: '擷取個人資料時出錯。請重試。',
    },

    linkListInput: {
      addField: '新增',
      removeField: '移除',
      invalidUrl: 'URL 無效。',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        timeIn: partName => `Time in ${partName}:`,
        totalTime: 'Total time in interview:',
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: '正在載入......',
      saving: '正在儲存......',
      sending: '正在傳送......',
    },

    modalApplicationForm: {
      applyForPosition: '申請職位',
      continue: '繼續',
      name: '輸入您的姓名',
      email: '輸入您的電子郵件地址',
      phoneNumber: '輸入您的電話號碼',
      links: '您可以輸入連結',
      legendLinks: '連結',
      legendAttachments: '附件',
      coverLetter: '求職信',
      attachments: '附件',
      introduction: '在此處寫下您的介紹',
      thankYou: '謝謝。',
      luck: '祝您好運！',
      close: '關閉',
    },

    modalConfirm: {
      cancel,
      confirm: '確定',
    },

    modalAlert: {
      close: '關閉',
    },

    modalLinkShare: {
      title: '可分享的公共連結',
      info: '此處有您可以分享的招聘廣告公開位址。\n任何對該職位感興趣的人都可以查看招聘廣告，\n然後決定是否申請。\n收到您的申請後，您會馬上收到常規通知。\n\n下面是招聘廣告的公開連結：',
    },

    modalVideoAdd: {
      chooseTitle: '新增新影片',
      title: '錄製新影片',
      titlePlaceholder: '在此處輸入影片標題',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: '上傳新影片',
      info: '允許的最大影片大小為 500mb。我們建議在上傳影片前對其進行壓縮，這樣上傳和轉換所需的時間會更短。',
    },

    modalCandidateInfo: [
      {
        headline: '錄製您的影片回覆 ',
        content: '次數不限。影片錄製完成後將立即儲存，您可以透過電子郵件中的連結返回影片面試。',
        mobileContent: '次數不限。將影片新增到面試中。您會看到影片上傳並儲存到面試中。您可以透過電子郵件中的連結返回影片面試。<br><br><strong>如果您使用的是 Apple 行動裝置且影片螢幕一直黑屏，您可以在<a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">此處</a>查看如何解決這個問題。</strong>',
      },
      {
        headline: '錄製後， ',
        content: '確保影片能正常播放，並且可以聽到您的聲音。按下「提交」按鈕後，您的回答將被鎖定，不能再修改。',
      },
      {
        headline: '當您完成面試時，',
        content: '按「傳送回答並完成面試」按鈕。在此之後，您就不能再返回到影片面試頁面了。如果您希望關閉此頁面，稍後繼續面試，請按「稍後繼續」按鈕。',
      },
      {
        headline: '如果您在回答影片面試問題方面需要幫助，',
        content: mailto => `請按一下頁面右下方的「支援」按鈕，或傳送電子郵件至 ${mailto}。`,
        customContent: link => `聯絡 ${link}`,
      },
    ],

    navigationBar: {
      back: '返回',
      dashboard: '儀表板',
      frontpage: '頭版',
    },

    personDetails: {
      stage: '階段',
      namePlaceholder: '申請人',
      contact: '聯絡方式',
      links: '連結',
      attachments: '附件',
      coverLetter: '求職信',
      referrer: '來源',
      referrerInfo: '申請人前往服務的網站。',
      noStage: '尚未進入任何階段',
      lastSeen: time => `上次被查看是在 ${time}。`,
      headerAdditionalInformation: '其他資訊',
      state: {
        invited: '受邀',
        visited: '造訪過',
        incomplete: '未完成',
        completed: '已完成',
      },
      notVisited: '尚未造訪面試頁面。',
      scheduledInterview: '面試資訊',
      scheduledInterviewInvitationSent: '受邀參加面試',
      scheduledInterviewInvitationExpired: '邀請已過期',
      scheduledInterviewInvitationEventCreated: '',
      scheduledInterviewReScheduleMeeting: '重新安排面試時間',
      otherPersons: count => `還找到 ${count} 個其他職位`,
    },

    phoneInput: {
      placeholder: example => `電話號碼格式：${example}`,
    },

    questionsAndResponses: {
      response: '回覆',
      noResponse: '未回覆',
      // used only in admin side so no translations needed
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: '您的評分',
      yourVotePlaceholder: '您還沒有表決意見。',
      totalVotes: count => `總共 ${count} 次評分`,
      noRatings: '暫無評分',
      mobileModalHeader: '新增您的評分',
      yourRatingReset: '重設您的表決意見',
      averageRating: '平均評分',
      reset: '重設',
    },

    share: {
      share: '分享到',
      copy: '複製連結',
    },

    sort: {
      sort: '排序',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: '選定',
      change: '變更',
    },

    video: {
      videoNotFound: '影片正在處理或未找到影片',
      retry: '再試一次',
      originalLanguageLabel: '原文',
      englishLanguageLabel: '英文',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? '上傳或錄製新影片' : '選擇檔案'),
      videoPlaceholder: '錄製您的回答',
      uploadPlaceholderCandidate: 'Upload your response',
      submit: '提交回答',
      notAnswered: '您尚未回答',
      remove: '移除拍攝內容',
      converting: '正在轉換影片。請稍候...',
      uploading: '正在上傳影片。請稍候...',
      error: {
        invalid: '所選檔案太大。請選擇其他檔案。',
        upload: '我們無法上傳影片，深表歉意。請重試。',
        transcode: '所選影片已損壞或無效，請重試。',
      },
    },

    virtualBg: {
      showMoreButtonText: '顯示更多內容',
      showLessButtonText: '顯示更少內容',
      infoText1:
        '錄製時，讓標籤頁在前臺處於活動狀態。錄製時，您不應使用任何其他應用程式。',
      infoText2:
        '影片背景影片在最新的瀏覽器和相對較新且功能強大的裝置上效果最佳。',
      infoText3: '確保目前沒有其他應用程式正在使用您的麥克風或攝影機。',
    },

    videoResponse: {
      videoPlaceholder: '錄製您的回答',
      submit: '提交回答',
      uploadPlaceholder: 'Upload your response',
      startInterview: '開始面試',
      notAnswered: '您尚未回答',
      required: '此問題需要回答',
    },

    webcam: {
      useVideoBgButtonText: '使用影片背景',
      removeVideoBgButtonText: '移除影片背景',
      starting: '正在啟動...',
      close: '關閉攝影機',
      remove: '移除拍攝內容',
      record: '錄製',
      stop: '停止',
      retake: '重做',
      submit: '提交回答',
      converting: '正在轉換影片。請稍候...',
      uploading: '正在上傳影片。請稍候...',
      downloading: '正在下載影片。請稍候...',
      processing: '正在處理...',
      uploadInProgress: '影片傳送仍在進行中，請勿關閉瀏覽器或變更頁面。',
      uploaded: '影片已傳送。',
      error: {
        DevicesNotFoundError: '無法使用攝影機或麥克風。請檢查它們是否已啟用。',
        NotFoundError: '無法使用攝影機或麥克風。請檢查它們是否已啟用。',
        NotAllowedError: '您沒有提供使用攝影機或麥克風的權限。',
        PermissionDismissedError: '您關閉了權限對話方塊。請提供使用攝影機和麥克風的權限。',
        PermissionDeniedError: '您已禁止我們使用您的攝影機或麥克風。',
        NotReadableError: '無法讀取攝影機或麥克風音像流。可能是硬體問題。',
        SecurityError: '由於安全錯誤，無法使用攝影機或麥克風',
        stream: '出現錯誤。請重新啟動瀏覽器。如果問題仍然存在，請嘗試使用其他瀏覽器。',
        download: '影片下載失敗。再試一次？',
        upload: '影片上傳失敗。再試一次？',
        emptyBlob: '您的瀏覽器或裝置記憶體已滿，無法進行錄製。請重新整體頁面，如果沒有用，請重新啟動瀏覽器。 如果問題仍然存在，請嘗試使用其他瀏覽器。',
        alternativeRecorder: '您也可以按一下此處以上傳檔案。',
        reconnecting: '連線中斷。正在嘗試重新連線。',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `您好！誠邀您參加影像面試${title}！本邀請也已發送至您的電子郵件信箱。`,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
